import styled from "styled-components";
import theme from "../../style/theme";
import { ContainedYellowButton } from "../button/ContainedYellowButton";
import { OutlinedGrayButton } from "../button/OutlinedGrayButton";

interface Props {
  confirmButtonText: string;
  disabled?: boolean;
  onClickInitButton: () => void;
  onClickConfirmButton: () => void;
}

export const DialogFooter: React.FC<Props> = ({
  confirmButtonText,
  disabled,
  onClickInitButton,
  onClickConfirmButton,
}) => {
  return (
    <>
      <Divider />
      <FooterContainer>
        <OutlinedGrayButton
          width="126px"
          height="51px"
          text={"초기화"}
          onClick={onClickInitButton}
        />
        <CreateButtonContainer>
          <ContainedYellowButton
            width="126px"
            height="51px"
            text={confirmButtonText}
            onClick={onClickConfirmButton}
            disabled={disabled}
          />
        </CreateButtonContainer>
      </FooterContainer>
    </>
  );
};

const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.25rem 2rem;
`;

const CreateButtonContainer = styled.div`
  margin-left: 0.5rem;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.palette.primitives.gray200};
`;
